<template>

<div>

    <!-- SIDE BAR SECTION -->
    <div class="fixed z-50">
        <adminSideBar/>
    </div>


<!-- NAV BAR SECTION -->
    <nav class="sticky w-full z-40 top-0 " >

        <adminNavBar/>

    </nav>

<!-- DASHBOARD -->

    <div class="flex bg-medalertBlue bg-opacity-10 w-full h-full">

       
        <div class="mt-3 w-full ml-60 font-euclid">

            <div class="container mt-10">

                <div class="flex h-60 px-8 pb-8 justify-between">

                    <div class=" bg-white h-full w-1/3 mx-6 cursor-pointer p-6 rounded-lg border-gray-700 hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all lg:p-3 duration-200 flex flex-col justify-center">
                        <span v-if="isLoading">
                            <Loading />
                        </span> 
                        <span v-if="!isLoading" >  <h2 class="font-medium text-4xl py-6">{{allClients.length}}</h2></span>
                        <h2 class="font-semibold text-xl" >Registered Clients</h2>
                    </div>

                    <div class=" bg-white h-full w-1/3 mx-6 cursor-pointer p-6 rounded-lg border-gray-700 hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all lg:p-3 duration-200 flex flex-col justify-center text-medalertBlue">
                        <span v-if="isLoading">
                            <Loading />
                        </span> 
                        <span v-if="!isLoading" ><h2 class="font-semibold text-4xl py-6">{{verifiedClients.length}}</h2></span>
                        <h2 class="font-semibold text-xl" >Verified Clients</h2>
                    </div>

                    <div class=" bg-white h-full w-1/3  mx-6 cursor-pointer p-6 rounded-lg border-gray-700 hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all lg:p-3 duration-200 flex flex-col justify-center text-medalertOrange">
                        <span v-if="isLoading">
                            <Loading />
                        </span> 
                        <span v-if="!isLoading" ><h2 class="font-semibold text-4xl py-6">{{unverifiedClients.length}}</h2></span>
                        <h2 class="font-semibold text-xl" >Unverified Clients</h2>
                    </div>
                    

                
                </div>

            </div>

            <div class="text-left font-semibold text-lg mx-12 my-4">
                Latest clients
            </div>

            <div  class="flex justify-center" v-if="isLoading">
                <Loader />
            </div>

            <div>
                <div class="bg-white h-auto  mx-12 rounded-md mt-4 mb-8">
                    <table class="table w-full text-left mx-auto rounded-md table-auto">
                        <thead class="bg-gray-200 py-2 font-light rounded-md">
                            <tr class="text-gray-700 text-sm" >
                                <th class="px-3 py-2">S/N</th>
                                <th class="px-3 py-2">Name</th>
                                <th class="px-3 py-2">Company Type</th>
                                <th class="px-3 py-2">CAC Reg No</th>
                                <th class="px-3 py-2">Verification</th>
                                <th class="px-3 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(client, index) in allClients" :key="index">
                                <td class="px-3 py-1">{{index + 1}}</td>
                                <td class="px-3 py-1">{{client.name}}</td>
                                <td class="px-3 py-1">{{client.type}}</td>
                                <td class="px-3 py-1">{{client.cac_registration_number}}</td>
                                <td class="px-3 py-1">{{client.is_verified}}</td>
                                <td class="px-3 py-2"><button button @click="reviewClient(client.id)" class="text-white bg-medalertBlue font-medium py-1 px-3 rounded-md hover:bg-medalertOrange "> Review </button></td>
                            </tr>
                            
                        </tbody>
                    </table>

                </div>
            </div>
            
        </div>





    </div>



</div>



  
</template>

<script>

import adminNavBar from '../components/AdminNavBar'
import adminSideBar from '../components/AdminSideBar'
import axios from 'axios';
import Loading from "../components/Loading";
import Loader from "../components/Loader";

import { ref } from 'vue'
import {useRouter} from 'vue-router'
import { useStore } from "vuex";


export default {

    components:{adminNavBar, adminSideBar, Loading, Loader},
    

    setup(){
        
        const router = useRouter();
        const success = ref("");
        const err = ref("");
        const allClients = ref([])
        const verifiedClients = ref([])
        const unverifiedClients = ref([])
        const isLoading = ref(false);

        const getAllClients = async () =>{
        try{
            isLoading.value = true;
            const response = await axios.get(`/api/v1/clients?page-number=1&limit=1000`)
            let allRegClients = response.data.data
            console.log(allRegClients)
            allClients.value = allRegClients

            isLoading.value = false;
        } catch(error){
            err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch all client";
        }
        }

        const getAllVerifiedClients = async () =>{
        try{
            isLoading.value = true;
            const response = await axios.get(`/api/v1/clients/verified?page-number=1&limit=1000`)
            let allVerifiedClients = response.data.data
            // console.log(allVerifiedClients)
            verifiedClients.value = allVerifiedClients

            isLoading.value = false;
        } catch(error){
            err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch all verified clients";
        }
        }

        const getAllUnverifiedClients = async () =>{
        try{
            isLoading.value = true;
            const response = await axios.get(`/api/v1/clients/unverified?page-number=1&limit=1000`)
            let allUnverifiedClients = response.data.data
            // console.log(allUnverifiedClients)
            unverifiedClients.value = allUnverifiedClients

            isLoading.value = false;
        } catch(error){
            err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch all unverified client";
        }
        }

        const reviewClient = async (id) => {
            router.push(`/client-details/${id}`);
            };


        return{
            err,
            success,
            getAllClients,
            getAllVerifiedClients,
            getAllUnverifiedClients,
            allClients,
            reviewClient,
            verifiedClients,
            unverifiedClients,
            isLoading 
        }
    },

    mounted(){
      this.getAllClients();
      this.getAllVerifiedClients()
      this.getAllUnverifiedClients()
    }

}
</script>

<style>

</style>